var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlachdach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.636,
    height: 55.193,
    viewBox: "0 0 78.636 55.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_14_2",
    "data-name": "Komponente 14 \\u2013 2",
    transform: "translate(0.287 0.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_34",
    "data-name": "Linie 34",
    y2: 31.572,
    transform: "translate(77.137 12.326)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_162",
    "data-name": "Pfad 162",
    d: "M132.963,148.723",
    transform: "translate(-79.151 -134.129)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_163",
    "data-name": "Pfad 163",
    d: "M130.111,149.269",
    transform: "translate(-85.87 -132.843)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_164",
    "data-name": "Pfad 164",
    d: "M148.635,156.853v34.328l-31.548-12.372V147.574Z",
    transform: "translate(-116.553 -136.837)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_165",
    "data-name": "Pfad 165",
    d: "M126.488,190.065l45.054-10.31V148.047l-45.054,7.69",
    transform: "translate(-94.405 -135.721)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_166",
    "data-name": "Pfad 166",
    d: "M120.185,148.628",
    transform: "translate(-109.254 -134.354)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_35",
    "data-name": "Linie 35",
    x2: 33.142,
    y2: 9.87,
    transform: "translate(44.896 1.811)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_167",
    "data-name": "Pfad 167",
    d: "M133.773,148.6",
    transform: "translate(-77.243 -134.415)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_168",
    "data-name": "Pfad 168",
    d: "M123.566,145.933",
    transform: "translate(-101.289 -140.703)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_169",
    "data-name": "Pfad 169",
    d: "M130.276,147.491",
    transform: "translate(-85.481 -137.032)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_170",
    "data-name": "Pfad 170",
    d: "M120.209,146.576",
    transform: "translate(-109.197 -139.188)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_36",
    "data-name": "Linie 36",
    y1: 7.587,
    x2: 46.939,
    transform: "translate(0 2.389)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_50",
    "data-name": "Gruppe 50",
    transform: "translate(9.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_171",
    "data-name": "Pfad 171",
    d: "M120.361,146.436v2.237l7.371,2.9",
    transform: "translate(-118.481 -139.517)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_49",
    "data-name": "Gruppe 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_48",
    "data-name": "Gruppe 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_172",
    "data-name": "Pfad 172",
    d: "M129.267,156.334l-9.466-7.2,32.634-4.758,8.995,6.563Z",
    transform: "translate(-119.801 -144.374)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linie_37",
    "data-name": "Linie 37",
    x2: 8.934,
    y2: 7.907,
    transform: "translate(16.978 2.283)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_38",
    "data-name": "Linie 38",
    x2: 7.649,
    y2: 6.769,
    transform: "translate(9.966 3.42)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_39",
    "data-name": "Linie 39",
    x2: 7.912,
    y2: 7.002,
    transform: "translate(25.432 1.65)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_53",
    "data-name": "Gruppe 53",
    transform: "translate(20.959 1.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_173",
    "data-name": "Pfad 173",
    d: "M123.9,147.308v2.623l8.641,3.4",
    transform: "translate(-121.45 -139.308)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_52",
    "data-name": "Gruppe 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_51",
    "data-name": "Gruppe 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_174",
    "data-name": "Pfad 174",
    d: "M134.27,158.944l-11.1-8.442,38.257-5.578,10.545,7.694Z",
    transform: "translate(-123.173 -144.924)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linie_40",
    "data-name": "Linie 40",
    x2: 8.652,
    y2: 7.656,
    transform: "translate(20.387 2.966)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_41",
    "data-name": "Linie 41",
    x2: 8.636,
    y2: 7.643,
    transform: "translate(12.03 4.179)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_42",
    "data-name": "Linie 42",
    x2: 8.94,
    y2: 7.912,
    transform: "translate(28.952 1.532)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Linie_43",
    "data-name": "Linie 43",
    y1: 6.167,
    x2: 37.231,
    transform: "translate(27.051 5.471)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_44",
    "data-name": "Linie 44",
    y1: 1.371,
    x2: 8.276,
    transform: "translate(14.565 6.948)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlachdach);
export default __webpack_public_path__ + "static/media/flachdach.bc0df01735470b739a782021a3d8e562.svg";
export { ForwardRef as ReactComponent };